/**
 * Shared login-target inference. Used by:
 *   - client AuthContext (reads window.location.search at form-mount time)
 *   - server Google OAuth callback (parses the `oauth_redirect` cookie that
 *     preserved the original client URL across the Google round-trip)
 *
 * Keep this file dependency-free: it runs in both the Vite-bundled browser
 * world and the Node server build.
 */

export type AuthType = "desktop" | "device" | "mcp" | "web";

export function inferAuthType(params: URLSearchParams): AuthType {
    if (params.get("is_desktop") === "true") {
        return "desktop";
    }
    if (params.get("verify_device") === "true") {
        return "device";
    }
    if (params.get("session_id")) {
        return "mcp";
    }
    return "web";
}

/**
 * Parse a raw URL (or `path?query` string) and run `inferAuthType` on its
 * query params. Returns 'web' if the input is empty, has no query string, or
 * fails to parse.
 */
export function inferAuthTypeFromUrl(url: string | undefined | null): AuthType {
    if (!url) {
        return "web";
    }
    try {
        const qIdx = url.indexOf("?");
        if (qIdx < 0) {
            return "web";
        }
        return inferAuthType(new URLSearchParams(url.slice(qIdx + 1)));
    } catch {
        return "web";
    }
}
